// extracted by mini-css-extract-plugin
export default {"container":"CvQpuc","title":"_Kekmv","description":"yriMaM"};